import {
  listSubaccountMemberships_listSubaccountMemberships,
  listSubaccountMemberships_listSubaccountMemberships_admin
} from "src/graphql/generated/listSubaccountMemberships";

export type Admin =
  listSubaccountMemberships_listSubaccountMemberships_admin & {
    invitedAtStr: string;
    invitedByStr: string;
    membership: listSubaccountMemberships_listSubaccountMemberships;
  };

export type InviteError =
  | "DELETED_ADMIN_ALREADY_EXISTS"
  | "ADMIN_ALREADY_EXISTS"
  | "UNKNOWN";

export function codeIsInviteError(code: string): code is InviteError {
  return (
    code === "DELETED_ADMIN_ALREADY_EXISTS" ||
    code === "ADMIN_ALREADY_EXISTS" ||
    code === "UNKNOWN"
  );
}

export type InviteResult =
  | {
      ok: false;
      error: InviteError;
    }
  | { ok: true };
